"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyData = exports.onGetMyDataSuccess = void 0;
const next12_utils_sonda_1 = __importDefault(require("@gcloud-npm/next12.utils.sonda"));
const next12_utils_monitoring_1 = require("@gcloud-npm/next12.utils.monitoring");
const next12_utils_request_1 = __importDefault(require("@gcloud-npm/next12.utils.request"));
const next12_utils_build_environments_1 = require("@gcloud-npm/next12.utils.build-environments");
const next12_utils_adabyron_1 = require("@gcloud-npm/next12.utils.adabyron");
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const next12_utils_environment_1 = require("@gcloud-npm/next12.utils.environment");
const index_1 = require("./normalizers/index");
const PATH = "datoscliente/misdatos";
const EVENT_NAME = "CLIENT.GET_MY_DATA";
const METHOD = "GET";
const onGetMyDataSuccess = (xhr, allowRedirection) => {
    const { data, responseURL } = xhr;
    if ((0, next12_utils_adabyron_1.isRedirectToLoginError)(responseURL) && next12_utils_common_1.isFrontApp) {
        if (allowRedirection) {
            window.location.href = (0, next12_utils_adabyron_1.normalizeRedirectError)(responseURL);
        }
        else {
            (0, next12_utils_common_1.deleteCookie)("wacsessionid");
            (0, next12_utils_common_1.deleteCookie)("LESESSION");
            (0, next12_utils_common_1.deleteCookie)("SMSESSION");
        }
        return null;
    }
    return (0, index_1.normalizeGetMyDataResponse)(data.datos);
};
exports.onGetMyDataSuccess = onGetMyDataSuccess;
const getMyData = ({ context, idFront = "TC", build = false, version, allowRedirection = true, }) => {
    const { environment, userType } = context;
    const { telco: connectionData } = environment;
    const { endpoint: host } = connectionData;
    const idRequest = (0, next12_utils_monitoring_1.getUUID)(idFront);
    const { prefixToApply } = (0, next12_utils_adabyron_1.getAdabyronConstants)(userType);
    const headers2Use = (0, next12_utils_build_environments_1.calculateHeaderParams)(build, next12_utils_environment_1.FAMILY_API.TELCO, context);
    const sonda = new next12_utils_sonda_1.default({
        eventName: EVENT_NAME,
        context,
        uniqueId: idRequest,
        origin: next12_utils_environment_1.PROCESS_NAME.CLIENT,
    });
    let queryParams = [];
    let urlParamsToReplace = [];
    const URL_API = (0, next12_utils_adabyron_1.getAdabyronURL_API)({
        path: PATH,
        version,
        idRequest,
        host,
        prefixToApply,
        queryParams,
        urlParamsToReplace,
    });
    const request = new next12_utils_request_1.default({
        method: METHOD,
        endpoint: URL_API,
        headers: headers2Use,
        onSuccess: (xhr) => (0, exports.onGetMyDataSuccess)(xhr, allowRedirection),
        sonda,
    });
    return request.makeRequest();
};
exports.getMyData = getMyData;
exports.default = exports.getMyData;
//# sourceMappingURL=index.js.map